<script>
import { destroySession } from '@/lib/api';
import { intercom } from '@/lib/analytics';
import getBrandConfig from '@/lib/utils/get_brand_config';
import getAuth0LogoutURL from '@/lib/utils/get_auth0_logout_url';
import errorStore from '@/store/error';

const _ = {
  destroySession,
  intercom,
  auth: getBrandConfig().auth,
  getAuth0LogoutURL,
  errorStore,
};

export default {
  _,

  async beforeRouteEnter(to, from, next) {
    _.intercom('shutdown');
    try {
      await _.destroySession();
      if (_.auth === 'auth0') {
        window.location.assign(_.getAuth0LogoutURL());
      } else {
        next('/');
      }
    } catch (exception) {
      _.errorStore.addError();
    }
  },

  methods: {
    destroySession,
  },
};
</script>
